// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { parseJSON as fn } from "../parseJSON.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const parseJSONWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default parseJSONWithOptions;
